import { render, staticRenderFns } from "./authenticating.component.vue?vue&type=template&id=00a9f8d8&scoped=true"
import script from "./authenticating.component.vue?vue&type=script&lang=ts&setup=true"
export * from "./authenticating.component.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./authenticating.component.vue?vue&type=style&index=0&id=00a9f8d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a9f8d8",
  null
  
)

export default component.exports